import { Container, Graphics } from "pixi.js";
import { indoor, windows } from "./common.js";

/** Bloque 11B: la sala de la asociación de estudiantes. */
export function aefiec(): Container {
  const scene = indoor({ wall: 0xeef0f4, floor: 0xc6ccd2 });

  windows(scene, 2, 64, 0xb3ddf2);

  // Banderines: lo que convierte una sala de reunión en la sede de una asociación.
  const flags = new Graphics();
  const colours = [0x2f6fb2, 0xe8c33c, 0xc0392b, 0x2f9e63, 0x8e44ad];
  for (let i = 0; i < 12; i++) {
    const x = 60 + i * 76;
    flags
      .moveTo(x, 30)
      .lineTo(x + 34, 30)
      .lineTo(x + 17, 66)
      .fill(colours[i % colours.length]!);
  }
  flags.moveTo(40, 30).lineTo(920, 30).stroke({ width: 3, color: 0x8f979c });
  scene.addChild(flags);

  const poster = new Graphics();
  poster.rect(660, 96, 200, 120).fill(0xf4f7fa).stroke({ width: 5, color: 0x2f6fb2 });
  poster.rect(686, 122, 148, 12).fill(0x2f6fb2);
  poster.rect(686, 148, 108, 10).fill({ color: 0x51606e, alpha: 0.6 });
  poster.rect(686, 168, 128, 10).fill({ color: 0x51606e, alpha: 0.6 });
  scene.addChild(poster);

  return scene;
}
